import { Input, Radio } from "antd";
import { CollegeRecommend, Recommend } from "@/pages/SchoolDiagnoseReport/type";
import React from "react";
type SchoolRecommend = {
  collegeRecommendList: Array<CollegeRecommend>;
  recommend: boolean;
  setCollegeRecommendList: ([]) => void;
  setRecommend: () => void;
};
const SchoolRecommend = (props) => {
  const {
    collegeRecommendList = [],
    recommend = true,
    setCollegeRecommendList,
    setRecommend,
  } = props;

  //收到更改智能推荐院校
  const handleChangeRecommend = (
    index: number,
    value: string,
    type: string
  ) => {
    collegeRecommendList[index][type] = value;
    setCollegeRecommendList([...collegeRecommendList]);
  };

  //处理是否选择智能推荐院校
  const handleRecommendSchool = (e) => {
    setRecommend(e.target.value);
  };
  return (
    <div className="school_diagnose__school">
      {/*<div className="school_diagnose__right-title">院校推荐</div>*/}
      <div className="school_diagnose__right-title">
        <div className="school_diagnose__right-title-prompt"></div>
        <span>院校推荐</span>
      </div>
      <div className="school_diagnose__recommend-wrapper">
        <div className="school_diagnose__recommend-radio">
          <span>智能推荐院校：</span>
          <Radio.Group
            name="radio_group"
            defaultValue={true}
            onChange={handleRecommendSchool}
          >
            <Radio value={true}>是</Radio>
            <Radio value={false}>否</Radio>
            {/*<span>777</span>*/}
          </Radio.Group>
          <div className="school_diagnose__recommend-prompt">
            智能推荐院校关闭状态下需手动填写推荐院校
          </div>
        </div>
        {collegeRecommendList.map((item: CollegeRecommend, index: number) => {
          return (
            <div className="school_diagnose__recommend" key={String(index)}>
              <span>
                {index === 0 ? "当前分数推荐院校：" : "目标分数推荐院校："}
              </span>
              <div className="school_diagnose__recommend">
                <span className="school_diagnose__recommend-desc">冲</span>
                <Input
                  style={{ width: "150px" }}
                  value={item.shock}
                  disabled={recommend}
                  maxLength={25}
                  onChange={(e) => {
                    handleChangeRecommend(
                      index,
                      e.target.value,
                      Recommend.SHOCK
                    );
                  }}
                ></Input>
              </div>
              <div className="school_diagnose__recommend">
                <span className="school_diagnose__recommend-desc">稳</span>
                <Input
                  style={{ width: "150px" }}
                  value={item.stable}
                  maxLength={25}
                  disabled={recommend}
                  onChange={(e) => {
                    handleChangeRecommend(
                      index,
                      e.target.value,
                      Recommend.STABLE
                    );
                  }}
                ></Input>
              </div>
              <div className="school_diagnose__recommend">
                <span className="school_diagnose__recommend-desc">保</span>
                <Input
                  style={{ width: "150px" }}
                  value={item.pocket}
                  maxLength={25}
                  disabled={recommend}
                  onChange={(e) => {
                    handleChangeRecommend(
                      index,
                      e.target.value,
                      Recommend.POCKET
                    );
                  }}
                ></Input>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SchoolRecommend;
